import { SvgIconProps } from "@mui/material";
import StyledSvgIcon from "./StyledSvgIcon";

export default ({
  color,
  ...props
}: Omit<SvgIconProps, "color"> & { color?: string }) => (
  <StyledSvgIcon
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    {...props}
    //sx={{ stroke: props.fill }}
  >
    <path
      transform="translate(375,-645) scale(0.57)"
      fill={color}
      d="M 0 428.403 L 76.3 428.403 A 125.721 125.721 0 0 0 90.382 459.321 A 99.673 99.673 0 0 0 116.9 487.203 A 105.97 105.97 0 0 0 154.134 503.583 Q 168.64 507.013 185.527 507.442 A 191.989 191.989 0 0 0 190.4 507.503 A 158.016 158.016 0 0 0 221.601 504.609 Q 240.025 500.896 254.366 492.419 A 86.864 86.864 0 0 0 267.4 483.003 A 80.23 80.23 0 0 0 293.963 433.799 A 116.749 116.749 0 0 0 295.4 415.103 Q 295.4 383.603 274.75 362.953 A 82.682 82.682 0 0 0 248.709 345.659 Q 234.248 339.416 215.6 336.703 L 154 327.603 A 268.259 268.259 0 0 1 108.168 315.715 Q 68.447 301.288 44.1 275.103 A 134.493 134.493 0 0 1 11.585 211.879 A 198.53 198.53 0 0 1 7 168.003 A 187.154 187.154 0 0 1 12.326 122.399 A 148.243 148.243 0 0 1 30.45 79.453 A 157.412 157.412 0 0 1 90.388 24.038 A 189.16 189.16 0 0 1 96.25 21.003 Q 138.6 0.003 194.6 0.003 A 261.334 261.334 0 0 1 244.024 4.464 A 196.399 196.399 0 0 1 292.6 20.303 Q 334.6 40.603 358.75 78.053 A 169.82 169.82 0 0 1 381.217 132.213 A 224.362 224.362 0 0 1 386.4 168.003 L 310.8 168.003 A 154.967 154.967 0 0 0 298.696 135.011 A 111.365 111.365 0 0 0 270.2 99.053 Q 240.8 74.903 194.6 74.903 A 169.411 169.411 0 0 0 162.415 77.773 Q 143.973 81.345 129.475 89.361 A 90.124 90.124 0 0 0 114.45 99.753 A 81.433 81.433 0 0 0 86.258 153.633 A 116.603 116.603 0 0 0 85.4 168.003 Q 85.4 200.203 106.05 220.503 A 86.39 86.39 0 0 0 131.905 237.716 Q 146.191 244.052 164.5 247.103 L 226.1 256.203 A 265.349 265.349 0 0 1 271.853 267.566 Q 312.208 281.782 336.7 308.353 A 136.661 136.661 0 0 1 369.806 374.289 A 198.182 198.182 0 0 1 373.8 415.103 A 193.134 193.134 0 0 1 368.801 460.01 A 150.912 150.912 0 0 1 351.05 503.653 Q 328.3 541.103 287 561.753 A 191.983 191.983 0 0 1 231.467 579.252 A 256.913 256.913 0 0 1 190.4 582.403 Q 134.4 582.403 92.75 563.853 A 162.992 162.992 0 0 1 47.643 534.489 A 147.918 147.918 0 0 1 26.95 510.653 Q 2.8 476.003 0 428.403 Z"
    />
    <path
      fill={color}
      d="M440-800v-120h80v120h-80Zm0 760v-120h80v120h-80Zm360-400v-80h120v80H800Zm-760 0v-80h120v80H40Zm708-252-56-56 70-72 58 58-72 70ZM198-140l-58-58 72-70 56 56-70 72Zm564 0-70-72 56-56 72 70-58 58ZM212-692l-72-70 58-58 70 72-56 58Z"
    />

    <circle
      cx="480"
      cy="-480"
      r="280"
      fill="none"
      strokeWidth="40"
      stroke={color}
    />
  </StyledSvgIcon>
);
